import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import { queryAssignedElements as l } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o$1 } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { getCookie } from '../../utilities/backend-helpers/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { TabsOrientation } from './enums.js';
import css_248z from './tabs.scss.js';
import img$1 from '../../../../assets/images/arrow-tab-left.svg.js';
import img from '../../../../assets/images/arrow-tab-right.svg.js';

class Tabs extends s {
    constructor() {
        super(...arguments);
        this.orientation = TabsOrientation.VERTICAL;
        this.rtl = false;
        this.visibleScroll = false;
        this.pointerShift = '0px';
        this.gatedContent = null;
        this.pointerWidth = '0px';
        this.isFirstTab = true;
        this.isLastTab = false;
        this.isTabletOrAbove = false;
    }
    updateArrowVisibilityByTabIndex() {
        const activeIndex = this.tabs.findIndex(tab => tab.selected);
        const lastIndex = this.tabs.length - 1;
        const rtl = this.rtl || isRTL();
        if (rtl) {
            this.isFirstTab = activeIndex === lastIndex;
            this.isLastTab = activeIndex === 0;
        }
        else {
            this.isFirstTab = activeIndex === 0;
            this.isLastTab = activeIndex === lastIndex;
        }
    }
    updateResponsiveState() {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        this.isTabletOrAbove = mediaQuery.matches;
        this.updateArrowVisibilityByTabIndex();
        const navList = this.renderRoot.querySelector('.nav-list');
        if (navList && this.isFirstTab) {
            navList.scrollLeft = 0;
        }
    }
    renderLeftArrow() {
        const rtl = this.rtl || isRTL();
        const direction = rtl ? 'right' : 'left';
        const icon = rtl ? img : img$1;
        if (!this.isTabletOrAbove || (rtl ? this.isLastTab : this.isFirstTab))
            return null;
        return x `<button class="arrow left" @click="${() => this.scrollTabs(direction)}" aria-label="Scroll ${direction}"><img src="${icon}" alt="" aria-hidden="true"></button>`;
    }
    renderRightArrow() {
        const rtl = this.rtl || isRTL();
        const direction = rtl ? 'left' : 'right';
        const icon = rtl ? img$1 : img;
        if (!this.isTabletOrAbove || (rtl ? this.isFirstTab : this.isLastTab))
            return null;
        return x `<button class="arrow right" @click="${() => this.scrollTabs(direction)}" aria-label="Scroll right"><img src="${icon}" alt="" aria-hidden="true"></button>`;
    }
    handleTabKeyDown(event) {
        const current = event.target;
        const tabs = Array.from(this.renderRoot.querySelectorAll('button[role="tab"]')).filter(tab => tab.getAttribute('aria-disabled') !== 'true');
        const currentIndex = tabs.findIndex(tab => tab === current);
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const selectedTab = tabs[currentIndex];
            selectedTab.click();
        }
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key))
            return;
        event.preventDefault();
        let nextIndex = currentIndex;
        switch (event.key) {
            case 'ArrowRight':
                nextIndex = (currentIndex + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = tabs.length - 1;
                break;
        }
        tabs[nextIndex].focus();
    }
    setActiveTab(selectedTab) {
        if (!selectedTab || selectedTab.selected)
            return;
        const prevActiveTab = this.tabs.find(tab => tab.selected);
        const newActiveTab = this.tabs.find(tab => tab === selectedTab);
        if (prevActiveTab)
            prevActiveTab.selected = false;
        if (newActiveTab)
            newActiveTab.selected = true;
        this.updateComplete.then(() => {
            this.tabs.forEach(tab => {
                const btn = this.renderRoot.querySelector(`button[name="${tab.name}"]`);
                if (btn && !tab.selected) {
                    btn.setAttribute('tabindex', '-1');
                }
            });
        });
        this.updateArrowVisibilityByTabIndex();
        this.requestUpdate();
    }
    firstUpdated() {
        const pageHash = window.location.hash.substring(1);
        const anchorTabIndex = this.tabs.findIndex(tab => tab.id && tab.id === pageHash);
        if (anchorTabIndex > -1) {
            const tab = this.tabs[anchorTabIndex];
            if (tab.tabId) {
                this.setActiveTab(this.tabs[0]);
                this.handleRestrictedContent(tab, true);
                return;
            }
            this.setActiveTab(tab);
            setTimeout(() => {
                this.scrollIntoView();
            }, 1000);
        }
        else {
            this.setActiveTab(this.tabs[0]);
        }
        window.addEventListener('resize', () => this.updateResponsiveState());
        this.updateResponsiveState();
    }
    updated() {
        const activeButton = this.shadowRoot.querySelector('nav button.selected');
        setTimeout(() => {
            this.pointerWidth = `${(activeButton === null || activeButton === void 0 ? void 0 : activeButton.clientWidth) || 0}px`;
            const navList = this.renderRoot.querySelector('.nav-list');
            if (!navList)
                return;
            if (this.rtl || isRTL()) {
                const navWidth = this.renderRoot.querySelector('.nav-list').clientWidth;
                this.pointerShift = `${navWidth -
                    ((activeButton === null || activeButton === void 0 ? void 0 : activeButton.offsetLeft) || 0) -
                    ((activeButton === null || activeButton === void 0 ? void 0 : activeButton.clientWidth) || 0)}px`;
            }
            else {
                this.pointerShift = `${(activeButton === null || activeButton === void 0 ? void 0 : activeButton.offsetLeft) || 0}px`;
            }
        }, 50);
    }
    handleRestrictedContent(tab, onFirstUpdated = false) {
        var _a;
        this.gatedContent = document.querySelector(`restricted-content[tabid="${tab.tabId}"]`);
        const allowBtn = (_a = this.gatedContent) === null || _a === void 0 ? void 0 : _a.querySelector('generic-button[allow] button');
        if (getCookie(`gated-tab-${tab.tabId}`) === '0' && !onFirstUpdated)
            return;
        if (getCookie(`gated-tab-${tab.tabId}`) === '0' && onFirstUpdated) {
            this.setActiveTab(this.tabs[0]);
            return;
        }
        if (getCookie(`gated-tab-${tab.tabId}`) === '1') {
            this.setActiveTab(tab);
            return;
        }
        this.gatedContent.showContent();
        allowBtn === null || allowBtn === void 0 ? void 0 : allowBtn.addEventListener('click', () => this.setActiveTab(tab));
    }
    handleTabClick(tab) {
        if (tab.redirectUrl) {
            window.location = tab.redirectUrl;
        }
        if (!tab.tabId)
            this.setActiveTab(tab);
        if (tab.tabId)
            this.handleRestrictedContent(tab);
    }
    renderTab(tab) {
        const isDisabled = tab.disabled;
        return x `<li role="presentation" class="tab-item"><button id="${tab.id}" class="${o({
            tab: true,
            selected: tab.selected,
            disabled: isDisabled,
        })}" role="tab" aria-selected="${tab.selected ? 'true' : 'false'}" aria-disabled="${isDisabled ? 'true' : 'false'}" @click="${() => !isDisabled && this.handleTabClick(tab)}" @keydown="${(e) => this.handleTabKeyDown(e)}"><span class="tab-text">${o$1(tab.name)}</span></button></li>`;
    }
    scrollTabs(direction) {
        const navList = this.renderRoot.querySelector('.nav-list');
        if (!navList)
            return;
        const tabs = Array.from(navList.querySelectorAll('button'));
        const activeIndex = tabs.findIndex(btn => btn.classList.contains('selected'));
        let nextIndex = activeIndex;
        const rtl = this.rtl || isRTL();
        if (direction === 'left') {
            nextIndex = rtl
                ? Math.min(tabs.length - 1, activeIndex + 1)
                : Math.max(0, activeIndex - 1);
        }
        else {
            nextIndex = rtl
                ? Math.max(0, activeIndex - 1)
                : Math.min(tabs.length - 1, activeIndex + 1);
        }
        const nextTab = tabs[nextIndex];
        if (nextTab) {
            nextTab.click();
            nextTab.scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest',
            });
        }
    }
    render() {
        const rtl = this.rtl || isRTL();
        const navClassMap = {
            'tabs-scroll-wrapper': true,
            'tabs-nav': true,
            [`tabs-${this.orientation}`]: true,
            'visible-scroll': this.visibleScroll,
            rtl,
            'align-right': rtl && this.orientation === TabsOrientation.VERTICAL,
            'align-left': !rtl && this.orientation === TabsOrientation.VERTICAL,
        };
        return x `<nav class="${o(navClassMap)}" aria-label="Section navigation"><div class="tabs-scroll-arrows">${this.renderLeftArrow()}<ul class="nav-list" role="tablist">${this.tabs.map(tab => this.renderTab(tab))}</ul>${this.renderRightArrow()}</div></nav><div class="content"><slot></slot></div>`;
    }
}
Tabs.styles = css_248z;
__decorate([
    l({ slot: '', flatten: true, selector: 'tab-item' })
], Tabs.prototype, "tabs", void 0);
__decorate([
    n({ type: String })
], Tabs.prototype, "orientation", void 0);
__decorate([
    n({ type: Boolean })
], Tabs.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], Tabs.prototype, "visibleScroll", void 0);
__decorate([
    t()
], Tabs.prototype, "pointerShift", void 0);
__decorate([
    t()
], Tabs.prototype, "gatedContent", void 0);
__decorate([
    t()
], Tabs.prototype, "pointerWidth", void 0);
__decorate([
    t()
], Tabs.prototype, "isFirstTab", void 0);
__decorate([
    t()
], Tabs.prototype, "isLastTab", void 0);
__decorate([
    t()
], Tabs.prototype, "isTabletOrAbove", void 0);
customElements.define('tabs-container', Tabs);

export { Tabs };
